import { Directive, OnDestroy, OnInit, ViewContainerRef, inject, input } from "@angular/core";
import { SlotService } from "common/slot.service";

@Directive({ selector: "[stagesSlot]" })
export class SlotDirective implements OnInit, OnDestroy {
	viewContainerRef = inject(ViewContainerRef);
	private slotService = inject(SlotService);

	readonly stagesSlot = input.required<string>();

	ngOnInit(): void {
		this.slotService.registerSlot(this.stagesSlot(), this.viewContainerRef);
	}

	ngOnDestroy(): void {
		this.slotService.destroySlot(this.stagesSlot(), this.viewContainerRef);
	}
}
